import {
  GlobalEvents,
  SnippetElement,
  Theme,
  defineElement,
  globalOn,
  liquidValue,
  on,
  param,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/util-product-form/util-product-form.ts
var UtilProductForm = class extends SnippetElement {
  get form() {
    return this.querySelector(`#${this.formId}`);
  }
  get formData() {
    return new FormData(this.form);
  }
  get formObj() {
    return Object.fromEntries(this.formData);
  }
  get currentVariant() {
    const obj = this.formObj;
    return this.variants.find((v) => {
      return v.option1 == obj.option1 && v.option2 == obj.option2 && v.option3 == obj.option3;
    });
  }
  submit(form, evt, skipAlcoholCheck = false) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      evt.preventDefault();
      (_a = this.addToCartBtn) == null ? void 0 : _a.setAttribute("loading", "");
      const addons = this.formData.getAll("addons").filter((a) => a !== "" && typeof a === "string");
      const formData = this.formData;
      const unique = (_c = (_b = formData.get("id")) == null ? void 0 : _b.toString()) != null ? _c : "000";
      formData.set("properties[_unique]", unique);
      const res = yield fetch(this.cartUrl, {
        method: "POST",
        headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
        body: formData
      }).then((res2) => __async(this, null, function* () {
        return yield res2.json();
      }));
      if (res.status === 422) {
        this.errorOutputs.forEach((e) => {
          e.show(res.description);
        });
      } else {
        this.errorOutputs.forEach((e) => {
          e.hide();
        });
        const stripIdentifier = (s) => s.replace(/\$\$.*$/, "");
        const addonItems = addons.map((a) => {
          var _a2, _b2, _c2, _d2;
          return {
            id: parseInt(stripIdentifier(a)),
            quantity: parseInt((_a2 = formData.get("quantity")) != null ? _a2 : "1"),
            properties: {
              _unique: unique,
              _type: (_b2 = formData.get(`type--${a}`)) != null ? _b2 : "addon",
              _custom: (_c2 = formData.get(`custom--${a}`)) != null ? _c2 : "",
              Text: (_d2 = formData.get(`text--${a}`)) != null ? _d2 : void 0
            }
          };
        });
        addonItems.length > 0 && (yield Theme.Cart.addItem(...addonItems));
        Theme.Cart.emit("updated");
        GlobalEvents.emit("cart:open");
      }
      (_d = this.addToCartBtn) == null ? void 0 : _d.removeAttribute("loading");
    });
  }
  updateSelectedVariant() {
    if (this.currentVariant) {
      this.form.elements.namedItem("id").value = this.currentVariant.id.toString();
      const url = new URL(window.location.href);
      url.searchParams.set("variant", this.currentVariant.id.toString());
      window.history.replaceState(null, "", url);
      GlobalEvents.emit("product:variantChanged", this.currentVariant);
    }
  }
};
__decorateClass([
  param("form_id")
], UtilProductForm.prototype, "formId", 2);
__decorateClass([
  liquidValue("routes.cart_add_url")
], UtilProductForm.prototype, "cartUrl", 2);
__decorateClass([
  liquidValue("product.variants")
], UtilProductForm.prototype, "variants", 2);
__decorateClass([
  queryAll("[data-form-error]")
], UtilProductForm.prototype, "errorOutputs", 2);
__decorateClass([
  query("[data-add-to-cart]")
], UtilProductForm.prototype, "addToCartBtn", 2);
__decorateClass([
  on("submit", "form")
], UtilProductForm.prototype, "submit", 1);
__decorateClass([
  globalOn("form:changeOption")
], UtilProductForm.prototype, "updateSelectedVariant", 1);
UtilProductForm = __decorateClass([
  defineElement("util-product-form")
], UtilProductForm);
export {
  UtilProductForm
};
